import { Box } from "@mui/material";
import styled from "@emotion/styled";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Icon } from "@iconify/react";
import { useState } from "react";
// css
import './Login.css'
import logo from '../../../Assets/images/logo.png';
// custom imports
import { HandleApiError } from "../../../Utils/CommonErrors/HandleApiError";
import { hideLoader, showLoader } from "../../../Redux/Slice/Loader/loaderSlice";
import { useDispatch } from "react-redux";
import showToast from "../../../Utils/Toast/ToastNotification";
import { userlogin } from "../../../Redux/Slice/Auth/AuthSlice";
import authService from "../../../Services/Login/LoginService";


const RootStyle = styled("div")({
  background: "rgb(249, 250, 251)",
  height: "100vh",
  display: "grid",
  placeItems: "center",
});

const HeadingStyle = styled(Box)({
  textAlign: "center",
});

const ContentStyle = styled("div")({
  maxWidth: 480,
  padding: 25,
  margin: "auto",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  background: "#fff",
});

// Easing for animation
let easing = [0.6, -0.05, 0.01, 0.99];
const animate = {
  opacity: 1,
  y: 0,
  transition: {
    duration: 0.6,
    ease: easing,
    delay: 0.16,
  },
};

const Login = () => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email is required")
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i,
        "Please enter valid email address"
      )
      .matches(/^$|^\S+.*/, "Only blank spaces are not valid."),
    password: Yup.string()
      .min(6, 'Password must be at least 6 characters')
      .required('Password is required'),
  });

  const initialValues = {
    email: '',
    password: '',
    // rememberMe: false,
    type: 'web'
  };


  const onSubmit = async (values) => {
    dispatch(showLoader())
    try {
      const response = await authService.login(values);
      if (response?.data?.statusCode === 200) {
        dispatch(userlogin(response));
        showToast("success", response?.data?.body?.message)
        // navigate('/dashboard');
      } else if (response?.data?.statusCode === 400) {
        showToast("error", response?.body?.message)
        return;
      }
    } catch (error) {
      await HandleApiError(error);
    } finally {
      dispatch(hideLoader())
    }
  };


  return (

    <section className="login-main">
      <div className="login-block d-flex">
        <div className="logo-mobile">
          <img src={logo}></img>
        </div>
        <div className="banner-img-block">
        </div>
        <div className="login-info-block d-flex flex-column align-items-center">
          <div className="logo">
            <img src={logo}></img>
          </div>
          <div className="signup-box">
            <div className="inner-box">
              <div className="d-flex">
                <h1 className="login_header">Login</h1>
              </div>

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ values, handleChange, handleSubmit, errors, touched }) => (
                  <Form className="login-form">
                    <div className="mb-3 email-blk">
                      <label htmlFor="email" className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Email"
                        value={values.email}
                        onChange={handleChange}
                      />
                      {touched.email && errors.email && (
                        <div className="error-text">{errors.email}</div>
                      )}
                    </div>

                    <div className="mb-3 position-relative">
                      <label htmlFor="password" className="form-label">Password</label>
                      <div className="input-group input-blk">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          id="password"
                          placeholder="Password"
                          value={values.password}
                          onChange={handleChange}
                        />
                        {/* <div className="eye-icon">
                            <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.28163 8.5C8.28163 9.19619 8.55819 9.86387 9.05047 10.3562C9.54276 10.8484 10.2104 11.125 10.9066 11.125C11.6028 11.125 12.2705 10.8484 12.7628 10.3562C13.2551 9.86387 13.5316 9.19619 13.5316 8.5C13.5316 7.80381 13.2551 7.13613 12.7628 6.64384C12.2705 6.15156 11.6028 5.875 10.9066 5.875C10.2104 5.875 9.54276 6.15156 9.05047 6.64384C8.55819 7.13613 8.28163 7.80381 8.28163 8.5ZM21.0832 7.89531C18.8613 3.21484 15.5027 0.859375 11.0004 0.859375C6.49569 0.859375 3.13944 3.21484 0.917567 7.89766C0.828447 8.08637 0.782227 8.29247 0.782227 8.50117C0.782227 8.70987 0.828447 8.91598 0.917567 9.10469C3.13944 13.7852 6.49804 16.1406 11.0004 16.1406C15.5051 16.1406 18.8613 13.7852 21.0832 9.10234C21.2637 8.72266 21.2637 8.28203 21.0832 7.89531ZM10.9066 12.625C8.6285 12.625 6.78163 10.7781 6.78163 8.5C6.78163 6.22188 8.6285 4.375 10.9066 4.375C13.1848 4.375 15.0316 6.22188 15.0316 8.5C15.0316 10.7781 13.1848 12.625 10.9066 12.625Z" fill="#718096" />
                            </svg>
                          </div> */}

                        <div
                          className="eye-icon"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: "pointer" }}
                        >
                          {showPassword ? (
                            <Icon icon="mdi:eye" width="24" height="24" />
                          ) : (
                            <Icon icon="mdi:eye-off" width="24" height="24" />
                          )}
                        </div>
                      </div>
                      {touched.password && errors.password && (
                        <div className="error-text">{errors.password}</div>
                      )}
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-3 pw-block">
                      <div className="form-check ps-0">
                        <div className="d-flex align-items-center">

                        </div>
                      </div>
                      <a href="/forgot-password" className="forgot-pw text-decoration-none">Forgot Password?</a>
                    </div>

                    <button type="submit" className="green-btn green-signin w-100" onClick={handleSubmit}>Login</button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default Login;
